import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Credits } from '@App/app/entities/admin-panel/credits.model';
import { ReportProblemDialogComponent } from '@App/app/shared/components/report-problem-dialog/report-problem-dialog/report-problem-dialog.component';
import { NbDialogService } from '@nebular/theme';

@Component({
  selector: 'app-credits-request-dropdown',
  templateUrl: './credits-request-dropdown.component.html',
  styleUrls: ['./credits-request-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditsRequestDropdownComponent {
  constructor(private dialogService: NbDialogService) {}

  @Input() credits: Credits | null;

  showReportForm() {
    this.dialogService.open(ReportProblemDialogComponent, {
      context: {
        category: 'processing',
        subcategory: 'credits',
        title: 'Processing Credit Request',
        description: 'I would like to add 10 GPx credits to my credit pool.',
      },
    });
  }
}
